import React from "react";

const Dates = () => {
    return (
        <div id={"dates_section"}>
            <h3>Dates</h3>

            <div className="imageContainer">
                <img src="/images/dates_section.png" alt="Date" />
            </div>

            <p>
                Date blocks allow you to work with calendar dates and perform operations like comparing, calculating, and formatting dates. These blocks are useful for scheduling, tracking time, and managing date-based logic in your app.
            </p>

            <ul>
                <li><strong>today</strong> – Returns the current date.</li>
                <br />
                <li><strong>get day from [date]</strong> – Extracts the day from a given date.</li>
                <br />
                <li><strong>add [number] day(s) to [date]</strong> – Adds the specified number of days to a date.</li>
                <br />
                <li><strong>date day [#] month [#] year [#]</strong> – Creates a date using the specified day, month, and year.</li>
                <br />
                <li><strong>is before [date]</strong> – Checks if one date occurs before another.</li>
                <br />
                <li><strong>get number of days from [date1] to [date2]</strong> – Calculates the number of days between two dates.</li>

            </ul>

            <p>
                <strong>Date Format:</strong> Date blocks use the format <code>'year month day'</code>, for example <code>'2025-09-30'</code>.
            </p>

        </div>
    );
};

export default Dates;
